"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputSchema = exports.generationConfig = exports.OcrValidationTesterRequestSchema = exports.OcrValidationConfigSchema = exports.CreateOcrExtractionConfigSchema = exports.updateOcrValidationSchema = exports.OcrContextSchema = exports.OcrExtractionModel = exports.OcrExtractionProvider = exports.OcrExtractionType = void 0;
const zod_1 = require("zod");
const open_ai_schema_object_1 = require("./open.ai.schema.object");
var OcrExtractionType;
(function (OcrExtractionType) {
    OcrExtractionType["NF"] = "NF";
})(OcrExtractionType = exports.OcrExtractionType || (exports.OcrExtractionType = {}));
var OcrExtractionProvider;
(function (OcrExtractionProvider) {
    OcrExtractionProvider["GOOGLE"] = "GOOGLE";
})(OcrExtractionProvider = exports.OcrExtractionProvider || (exports.OcrExtractionProvider = {}));
var OcrExtractionModel;
(function (OcrExtractionModel) {
    OcrExtractionModel["GEMNI_PRO_1_5"] = "gemini-1.5-pro";
})(OcrExtractionModel = exports.OcrExtractionModel || (exports.OcrExtractionModel = {}));
exports.OcrContextSchema = zod_1.z.object({ context: zod_1.z.record(zod_1.z.string(), zod_1.z.any()).optional() });
exports.updateOcrValidationSchema = zod_1.z.object({
    validations: zod_1.z.array(zod_1.z.object({ formula: zod_1.z.string().min(1), failure_message: zod_1.z.string().min(1) })),
});
exports.CreateOcrExtractionConfigSchema = zod_1.z.object({
    type: zod_1.z.nativeEnum(OcrExtractionType),
    model: zod_1.z.nativeEnum(OcrExtractionModel).optional(),
    provider: zod_1.z.nativeEnum(OcrExtractionProvider).optional(),
    prompt: zod_1.z.string(),
    limiting: zod_1.z.number().int().optional(),
});
exports.OcrValidationConfigSchema = zod_1.z.array(zod_1.z.object({
    formula: zod_1.z.string().min(1),
    failure_message: zod_1.z.string().min(1),
}));
exports.OcrValidationTesterRequestSchema = zod_1.z.object({
    validations: exports.OcrValidationConfigSchema,
    context: zod_1.z.record(zod_1.z.string(), zod_1.z.any()).optional(),
});
exports.generationConfig = {
    temperature: 0.45,
    topP: 0.85,
    topK: 40,
    maxOutputTokens: 2048,
    responseMimeType: 'application/json',
    responseSchema: {
        type: open_ai_schema_object_1.SchemaType.OBJECT,
        properties: {
            confiabilidade: {
                type: open_ai_schema_object_1.SchemaType.NUMBER,
                description: 'de 0 a 1 indica a porcentagem de confiança dos dados extraídos',
            },
            nota: {
                type: open_ai_schema_object_1.SchemaType.OBJECT,
                properties: {
                    prefeitura: {
                        type: open_ai_schema_object_1.SchemaType.STRING,
                        description: '',
                    },
                    data_emissao: {
                        type: open_ai_schema_object_1.SchemaType.STRING,
                        description: 'Data de emissão da nota fiscal, formatado em padrão ISO 8601',
                    },
                    valor: {
                        type: open_ai_schema_object_1.SchemaType.NUMBER,
                        description: 'Valor da nota fiscal',
                    },
                    valor_final: {
                        type: open_ai_schema_object_1.SchemaType.NUMBER,
                        description: 'Valor final da nota fiscal. Muitas vezes esse valor está em VALOR TOTAL DA NOTA',
                    },
                    numero_nf: {
                        type: open_ai_schema_object_1.SchemaType.STRING,
                        description: 'Número da nota fiscal',
                    },
                    codigo_servico: {
                        type: open_ai_schema_object_1.SchemaType.STRING,
                        description: 'Código de serviço da nota fiscal. O código do serviço geralmente possui 3 ou 4 caracteres numéricos, podendo ou não ser separado por um ponto. O(s) primeiro(s) dígito(s) indica o código geral, e o terceiro/quarto digito representa uma categoria do serviço. Exemplo: 10.09 (também pode ser representado como 1009)',
                    },
                    impostos: {
                        type: open_ai_schema_object_1.SchemaType.ARRAY,
                        items: {
                            type: open_ai_schema_object_1.SchemaType.OBJECT,
                            properties: {
                                nome: {
                                    type: open_ai_schema_object_1.SchemaType.STRING,
                                    description: 'Nomes dos impostos da nota',
                                },
                                valor: {
                                    type: open_ai_schema_object_1.SchemaType.NUMBER,
                                    description: 'Vales dos impostos da nota',
                                },
                            },
                            required: ['nome', 'valor'],
                        },
                    },
                    dados_adicionais: {
                        type: open_ai_schema_object_1.SchemaType.OBJECT,
                        description: 'Caso tenham campos adicionais, por exemplo campos específicos de prefeituras, iremos adicionar aqui',
                        properties: {
                            data_rps: {
                                type: open_ai_schema_object_1.SchemaType.STRING,
                                description: 'Data de RPS geralmente é um campo específico para algumas prefeituras como São Paulo',
                            },
                        },
                    },
                },
                required: [
                    'prefeitura',
                    'data_emissao',
                    'valor',
                    'valor_final',
                    'numero_nf',
                    'codigo_servico',
                    'impostos',
                    'dados_adicionais',
                ],
            },
            tomador: {
                type: open_ai_schema_object_1.SchemaType.OBJECT,
                description: 'Dados de quem está recebendo a nota fiscal',
                properties: {
                    cpf_cnpj: {
                        type: open_ai_schema_object_1.SchemaType.STRING,
                        description: 'Documento (por exemplo CPF ou CNPJ) do tomador',
                    },
                    razao_social: {
                        type: open_ai_schema_object_1.SchemaType.STRING,
                        description: 'Razão social da empresa tomadora dos serviços',
                    },
                    endereco: {
                        type: open_ai_schema_object_1.SchemaType.OBJECT,
                        properties: {
                            logradouro: {
                                type: open_ai_schema_object_1.SchemaType.STRING,
                                description: 'Logradouro da empresa tomadora dos serviços',
                            },
                            cep: {
                                type: open_ai_schema_object_1.SchemaType.STRING,
                                description: 'CEP da empresa tomadora dos serviços',
                            },
                            complemento: {
                                type: open_ai_schema_object_1.SchemaType.STRING,
                                description: 'Complemento da empresa tomadora dos serviços',
                            },
                            bairro: {
                                type: open_ai_schema_object_1.SchemaType.STRING,
                                description: 'Bairro da empresa tomadora dos serviços',
                            },
                            municipio: {
                                type: open_ai_schema_object_1.SchemaType.STRING,
                                description: 'Município da empresa tomadora dos serviços',
                            },
                            estado: {
                                type: open_ai_schema_object_1.SchemaType.STRING,
                                description: 'Estado ou UF da empresa tomadora dos serviços',
                            },
                        },
                        required: ['logradouro', 'cep', 'complemento', 'bairro', 'municipio', 'estado'],
                    },
                },
                required: ['cpf_cnpj', 'razao_social', 'endereco'],
            },
            prestador: {
                type: open_ai_schema_object_1.SchemaType.OBJECT,
                properties: {
                    cpf_cnpj: {
                        type: open_ai_schema_object_1.SchemaType.STRING,
                        description: 'o cpf ou cnpj do prestador de serviços que emitiu a nota fiscal',
                    },
                    razao_social: {
                        type: open_ai_schema_object_1.SchemaType.STRING,
                        description: 'a razão social ou nome do prestador de serviços que emitiu a nota fiscal',
                    },
                    endereco: {
                        type: open_ai_schema_object_1.SchemaType.OBJECT,
                        properties: {
                            logradouro: {
                                type: open_ai_schema_object_1.SchemaType.STRING,
                                description: 'o endereço do prestador de serviços que emitiu a nota fiscal',
                            },
                            cep: {
                                type: open_ai_schema_object_1.SchemaType.STRING,
                                description: 'o CEP do endereço do prestador de serviços que emitiu a nota fiscal',
                            },
                            complemento: {
                                type: open_ai_schema_object_1.SchemaType.STRING,
                                description: 'complemento do endereço do prestador de serviços que emitiu a nota fiscal',
                            },
                            bairro: {
                                type: open_ai_schema_object_1.SchemaType.STRING,
                                description: 'o bairro do endereço do prestador de serviços que emitiu a nota fiscal',
                            },
                            municipio: {
                                type: open_ai_schema_object_1.SchemaType.STRING,
                                description: 'o município ou cidade do endereço do prestador de serviços que emitiu a nota fiscal',
                            },
                            uf: {
                                type: open_ai_schema_object_1.SchemaType.STRING,
                                description: 'a unidade federativa (ou estado) do prestador de serviços que emitiu a nota fiscal',
                            },
                            simples_nacional: {
                                type: open_ai_schema_object_1.SchemaType.BOOLEAN,
                                description: 'se o prestador de serviços é optante do simples nacio',
                            },
                        },
                        required: ['logradouro', 'cep', 'bairro', 'municipio', 'uf'],
                    },
                },
                required: ['cpf_cnpj', 'razao_social', 'endereco'],
            },
        },
        required: ['confiabilidade', 'nota', 'tomador', 'prestador'],
    },
};
exports.InputSchema = {
    [OcrExtractionType.NF]: exports.generationConfig,
};
